{
  "title": "LX CONNECT",
  "menu": {
    "applications": "Applicazioni",
    "back": "Indietro",
    "campaigns": "Campagne",
    "dashboard": "Pannello di controllo",
    "devices": "Stazione locale S4",
    "dtwins": {
      "label": "Apparati",
      "manage": {
        "fleets": "Flotte",
        "label": "Gestisci",
        "devices": "Apparati"
      },
      "overview": {
        "label": "Panoramica",
        "map": "Mappa"
      }
    },
    "logout": "Disconnessione",
    "logs": "Registro",
    "overview": "Sintesi",
    "parameters": {
      "label": "Impostazioni",
      "platformMgt": "Gestione della piattaforma",
      "features": {
        "applicationManagement": "Gestione delle applicazioni",
        "firmwareManagement": "Gestione dei firmware",
        "deviceConfiguration": "Configurazione degli apparati",
        "label": "Funzionalità",
        "licenseManagement": "Gestione della licenza"
      },
      "monitoring": {
        "label": "Monitoraggio",
        "settings": "Configurazioni"
      }
    },
    "product": "Prodotto",
    "sector": {
      "label": "Rete",
      "placeholder": "Selezionare una rete"
    },
    "sectors": "Reti",
    "settings": "Configurazioni",
    "users": "Utenti"
  },
  "header": {
    "sectors": "Reti",
    "userMenu": {
      "title": "Menu dell’account",
      "logout": "Disconnessione",
      "userAccount": "Account utente",
      "about": "Informazioni",
      "connectMyMobileApp": "Connessione della mia applicazione mobile"
    },
    "admin": "Amministrazione"
  }
}
